import { cfgCdnBase } from '@infinitro/config';
import Favorites from './icons-fomoio/favorites.svelte';
import Featurebuyin from './icons-fomoio/featurebuyin.svelte';
import GameShowsIcon from './icons-fomoio/game_shows.svelte';
import HotIcon from './icons-fomoio/hot.svelte';
import LiveCasinoIcon from './icons-fomoio/live_casino.svelte';
import LobbyIcon from './icons-fomoio/lobby.svelte';
import NewIcon from './icons-fomoio/new.svelte';
import OriginalsIcon from './icons-fomoio/originals.svelte';
import ProviderIcon from './icons-fomoio/providers.svelte';
import RecentlyPlayedIcon from './icons-fomoio/recently_played.svelte';
import SlotIcon from './icons-fomoio/slot.svelte';
import SportsIcon from './icons-fomoio/sports.svelte';
// others
import FomoBets from './icons-fomoio/fomo_bets.svelte';
import FomoJackpot from './icons-fomoio/fomo_jackpot.svelte';
import Promotion from './icons-fomoio/promotion.svelte';
import Raffles from './icons-fomoio/raffles.svelte';
import ReferEarn from './icons-fomoio/refer_earn.svelte';
import Tournaments from './icons-fomoio/tournaments.svelte';
import VipClub from './icons-fomoio/vip-club.svelte';
import AmericanFootball from './icons-sport/american-football.svelte';
import AussieRules from './icons-sport/aussie-rules.svelte';
import Baseball from './icons-sport/baseball.svelte';
import Basketball from './icons-sport/basketball.svelte';
import Boxing from './icons-sport/boxing.svelte';
import CounterStrike from './icons-sport/counter-strike.svelte';
import Cricket from './icons-sport/cricket.svelte';
import Cycling from './icons-sport/cycling.svelte';
import Darts from './icons-sport/darts.svelte';
import Dota from './icons-sport/dota.svelte';
import ECricket from './icons-sport/e-cricket.svelte';
import Efighting from './icons-sport/e-fighting.svelte';
import EhorseRacing from './icons-sport/e-horse-racing.svelte';
import F1 from './icons-sport/f1.svelte';
import FavoritesSport from './icons-sport/favorites.svelte';
import Fifa from './icons-sport/fifa.svelte';
import Football from './icons-sport/football.svelte';
import Futsal from './icons-sport/futsal.svelte';
import Golf from './icons-sport/golf.svelte';
import Handball from './icons-sport/handball.svelte';
import IceHockey from './icons-sport/iceHockey.svelte';
import LeagueOfLegends from './icons-sport/league-of-legends.svelte';
import Live from './icons-sport/live.svelte';
import Mma from './icons-sport/mma.svelte';
import MyBets from './icons-sport/my-bets.svelte';
import Nba_2k from './icons-sport/nba-2k.svelte';
import Nfl from './icons-sport/nfl.svelte';
import Racing from './icons-sport/racing.svelte';
import Rugby from './icons-sport/rugby.svelte';
import Schedule from './icons-sport/schedule.svelte';
import Snooker from './icons-sport/snooker.svelte';
import Specials from './icons-sport/specials.svelte';
import Squash from './icons-sport/squash.svelte';
import Starcraft from './icons-sport/starcraft.svelte';
import TableTennis from './icons-sport/table-tennis.svelte';
import Tennis from './icons-sport/tennis.svelte';
import Volleyball from './icons-sport/volleyball.svelte';
import Waterpolo from './icons-sport/waterpolo.svelte';
const CDN_BASE = cfgCdnBase();
export const fomoIcons = {
    // category
    CardsIcon: LobbyIcon,
    LobbyIcon: LobbyIcon,
    OriginalsIcon: OriginalsIcon,
    PopularIcon: HotIcon,
    NewGamesIcon: NewIcon,
    PromotionIcon: Promotion,
    GameShowsIcon: GameShowsIcon,
    ProviderIcon: ProviderIcon,
    FeatureBuyInIcon: Featurebuyin,
    SlotsIcon: SlotIcon,
    ReferralIcon: ReferEarn,
    AffiliateIcon: SlotIcon,
    VipIcon: VipClub,
    BlogIcon: `${CDN_BASE}/themes/fomoio/sidebar/blog.png`,
    LeaderboardIcon: `${CDN_BASE}/themes/fomoio/sidebar/fomoioraces.png`,
    LiveCasinoIcon: LiveCasinoIcon,
    AllGamesIcon: SlotIcon,
    RecentlyPlayedIcon: RecentlyPlayedIcon,
    FavoritesUserIcon: Favorites,
    SportsIcon: SportsIcon,
    FomoBetsIcon: FomoBets,
    JackpotIcon: FomoJackpot,
    TournamentsIcon: Tournaments,
    RafflesIcon: Raffles,
    ReferEarnIcon: ReferEarn,
    /* SPORTS */
    FootballIcon: Football,
    IceHockeyIcon: IceHockey,
    BaseballIcon: Baseball,
    TennisIcon: Tennis,
    GolfIcon: Golf,
    AmericanFootballIcon: AmericanFootball,
    RugbyIcon: Rugby,
    VolleyballIcon: Volleyball,
    FutsalIcon: Futsal,
    MmaIcon: Mma,
    F1Icon: F1,
    CyclingIcon: Cycling,
    DartsIcon: Darts,
    SnookerIcon: Snooker,
    BoxingIcon: Boxing,
    WaterpoloIcon: Waterpolo,
    CricketIcon: Cricket,
    SpecialsIcon: Specials,
    BetsIcon: MyBets,
    DotaIcon: Dota,
    eCricketIcon: ECricket,
    FavoritesIcon: FavoritesSport,
    FifaIcon: Fifa,
    LoLIcon: LeagueOfLegends,
    LiveIcon: Live,
    NBA2KIcon: Nba_2k,
    CounterStrikeIcon: CounterStrike,
    ScheduleIcon: Schedule,
    BasketballIcon: Basketball,
    RacingIcon: Racing,
    NFLIcon: Nfl,
    EfightingIcon: Efighting,
    EhorseRacingIcon: EhorseRacing,
    AussieRulesIcon: AussieRules,
    HandballIcon: Handball,
    SquashIcon: Squash,
    TableTennisIcon: TableTennis,
    StarCraftIcon: Starcraft
};
// https://gmcdn.org/themes/fomoio/sidebar/featurebuyin.svg
